import * as React from 'react';
import { Feature } from '@tencent/workbench';
import BaseColorFeature from '@framework/workbench/common/feature/base-color-feature';
import { config } from './config';
import { ColorPickerType, ColorSourceType } from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import {
    TDWActionType, TDWVer5Type,
    TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';

@Feature()
export class ForeColorFeature extends BaseColorFeature {
    id = config.id;
    config = config;
    color: ITDColor = new TDColor({});

    public getColorDropDownContent = menuType => this.getColorPickerDropDownContent({
        onColorChange: (color: ITDColor, source?: ColorSourceType) => {
            this.handleFontColorChange(color);
            this.getColorPickerManager()?.colorPickerTdwReport({
                color: color?.srgb_color,
                colorPickerFrom: menuType,
                colorGroupFrom: source,
                actionType: TDWVer5Type.COLOR_PICKER_FORE_FONT,
            });
        },
        colorPickerType: ColorPickerType.StandardPC,
    });

    /**
     * 字体颜色修改
     * @param color
     */
    public handleFontColorChange = (color: ITDColor) => {
        this.getMenuManager()?.toolbarMenu()
            .callback(MenuType.TOOLBAR, this.id, color, color);
        this.saveRecentColorWithId(color);
    };
}
